import { readStoredJson } from '../storage/localStore';

/**
 * The reading streak: consecutive days with at least one finished page.
 * The legacy runtime appends today's date to qc2_days whenever a page is
 * finished (flowFinishedReading); this derives the streak from those dates.
 * A streak is alive if its most recent day is today or yesterday — reading
 * yesterday keeps today's chip lit until the day is missed outright.
 */
export function computeReadingStreak(days: readonly string[], today: Date = new Date()): number {
  const have = new Set(days);
  const day = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
  const key = (d: Date) => d.toISOString().slice(0, 10);
  if (!have.has(key(day))) {
    day.setUTCDate(day.getUTCDate() - 1); /* not read yet today — count from yesterday */
    if (!have.has(key(day))) return 0;
  }
  let streak = 0;
  while (have.has(key(day))) {
    streak++;
    day.setUTCDate(day.getUTCDate() - 1);
  }
  return streak;
}

export function loadReadingStreak(): number {
  return computeReadingStreak(readStoredJson<string[]>('qc2_days', []));
}
